import React, { Component } from "react";
import { connect } from "react-redux";
import {
  MapContainer,
  TileLayer,
  LayerGroup,
  Popup,
  Polyline,
  Marker,
  LayersControl,
} from "react-leaflet";
import {
  setStations,
  setLocations,
  setOrigin,
  setDestination,
  requestTrip,
  setUserPosition,
  getRoutes,
  setCity,
} from "../actions";
import { withRouter } from "react-router";
import {
  metropolRadRuhr,
  BusCircleIcon,
  UBahnCircleIcon,
  SBahnCircleIcon,
  TramCircleIcon,
  RECircleIcon,
  PositionBullsEyeIcon,
} from "../icons/Icons";
import {
  CloseIcon,
  LocationAMapIcon,
  LocationBMapIcon,
  LargeUBahnCircleIcon,
  LargeSBahnCircleIcon,
  LargeBusCircleIcon,
} from "../icons/Icons";
import {
  LargeTramCircleIcon,
  LargeRECircleIcon,
  parkAndRide,
  bikeAndRide,
  kundencenter,
  stadtmobil,
  metropolRadRuhrBike,
} from "../icons/Icons";
import "leaflet-contextmenu";
import "leaflet-contextmenu/dist/leaflet.contextmenu.css";
import { StyledH2 } from "../components/Styles";
import { Link } from "react-router-dom";
import StationMarker from "../components/StationMarker";
import LocationMarker from "../components/LocationMarker";
import ElevatorMarker from "../components/ElevatorMarker";
import EscalatorMarker from "../components/EscalatorMarker";

class MapView extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  constructor(props) {
    super(props);

    this.leafMap = null;

    this.state = {
      position: [51.455, 7.011],
      map: null,
      zoom: 14,
    };

    this.setOrigin = this.setOrigin.bind(this);
    this.setDestination = this.setDestination.bind(this);
    this.routeOrigin = this.routeOrigin.bind(this);
    this.routeDestination = this.routeDestination.bind(this);
    this.componentDidUpdate = this.componentDidUpdate.bind(this);
    this.changeBounds = this.changeBounds.bind(this);
    this.initMap = this.initMap.bind(this);
    this.getNewCenter = this.getNewCenter.bind(this);

    if (this.props.trip && this.props.trip.originalTrip) {
      this.changeBounds(this.props.trip.originalTrip.bounds);
    }
  }

  getNewCenter() {
    if (this.props.location.search !== "") {
      let paramsArr = this.props.location.search
        .slice(1, this.props.location.search.length)
        .split("&");
      let params = [];
      paramsArr.forEach((param) => {
        params.push({
          name: param.split("=")[0],
          value: param.split("=")[1],
        });
      });

      let lat, lng;
      if (params.length > 0) {
        params.forEach((param) => {
          if (param.name === "lat") {
            lat = param.value;
          } else if (param.name === "lng") {
            lng = param.value;
          }
        });
      }
      if (
        lat &&
        lng &&
        (this.state.position[0] != lat || this.state.position[1] != lng)
      ) {
        this.setState(
          {
            position: [lat, lng],
          },
          () => {
            if (this.leafMap) {
              this.setView([lat, lng], 14);
            }
          }
        );
      }
    }
  }

  setOrigin(data) {
    this.props.setOrigin(data);
  }

  setDestination(data) {
    this.props.setDestination(data);
  }

  componentDidUpdate(prevProp) {
    if (
      this.props.trip &&
      this.props.trip.originalTrip &&
      prevProp.trip !== this.props.trip
    ) {
      this.changeBounds(this.props.trip.originalTrip.bounds);
    }
    if (
      prevProp.departureStation !== this.props.departureStation &&
      this.props.departureStation.station !== null
    ) {
      this.jumpToPos({
        lat: this.props.departureStation.station.coords.lat,
        lng: this.props.departureStation.station.coords.long,
      });
    }
  }

  initMap(mapRef) {
    this.leafMap = mapRef;
    if (mapRef) {
      mapRef.on("zoomend", () => {
        this.setState({ zoom: mapRef.getZoom() });
      });
      mapRef.on("click", (e) => {
        if (window.innerWidth < 1224) {
          mapRef.fire("contextmenu", e);
        }
      });
    }

    if (this.props.trip && this.props.trip.originalTrip) {
      this.changeBounds(this.props.trip.originalTrip.bounds);
    }

    this.getNewCenter();
  }

  jumpToPos(pos, zoom = 16) {
    if (this.leafMap) {
      this.leafMap.flyTo(pos, zoom);
    }
  }

  setView(pos, zoom = 16) {
    if (this.leafMap) {
      this.leafMap.setView(pos, zoom);
    }
  }

  changeBounds(bounds) {
    if (this.leafMap) {
      this.leafMap.fitBounds(bounds);
    }
  }

  routeOrigin(data) {
    let _coords = [
      ("" + data.latlng.lat).replace(".", "").substring(0, 8),
      ("" + data.latlng.lng).replace(".", "").substring(0, 7),
    ];
    this.props.setOrigin({
      type: "coord",
      name: "Markierter Ort",
      id: "coord:" + _coords[1] + ":" + _coords[0] + ":WGS84",
      quality: "1000",
      coords: { lat: _coords[0] / 1000000, long: _coords[1] / 1000000 },
    });
    this.props.history.push("/tripRequest");
  }

  routeDestination(data) {
    let _coords = [
      ("" + data.latlng.lat).replace(".", "").substring(0, 8),
      ("" + data.latlng.lng).replace(".", "").substring(0, 7),
    ];
    this.props.setDestination({
      type: "coord",
      name: "Markierter Ort",
      id: "coord:" + _coords[1] + ":" + _coords[0] + ":WGS84",
      quality: "1000",
      coords: { lat: _coords[0] / 1000000, long: _coords[1] / 1000000 },
    });
    this.props.history.push("/tripRequest");
  }

  render() {
    let elevators = [],
      escalators = [];
    this.props.stations.forEach((station) => {
      station.elevators.forEach((elevator) => {
        elevator.station = station;
        elevators.push(elevator);
      });
    });
    this.props.stations.forEach((station) => {
      station.escalators.forEach((escalator) => {
        escalator.station = station;
        escalators.push(escalator);
      });
    });
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {this.props.location.pathname.includes("map") ? (
          <header>
            <StyledH2>
              Karte
              <Link
                to="/tripRequest"
                style={{
                  color: "white",
                  textDecoration: "none",
                }}
              >
                <CloseIcon style={{ height: "20pt" }} />
              </Link>
            </StyledH2>
          </header>
        ) : null}
        <MapContainer
          whenCreated={(map) => {
            this.initMap(map);
          }}
          tap={false}
          zoom="14"
          center={this.state.position}
          style={{ height: "100%", width: "100%" }}
          contextmenu={true}
          contextmenuWidth="120"
          contextmenuItems={[
            {
              text: '<div style="display: flex; gap: 5px; padding: 5px;"><svg style="height:20px" viewBox="0 0 512 512"><g fill="white"><circle cx="256" cy="256" r="200" /></g><g fill="#14CC14"><polygon points="256.5,183.1 227.7,280.9 283.5,280.9 257.1,183.1 "/><path d="M256,49C141.7,49,49,141.7,49,256s92.7,207,207,207s207-92.7,207-207S370.3,49,256,49z M306.3,360.7l-14.7-50.4h-72l-15,50.4h-38.4l70.2-209.4h42l67.5,209.4H306.3z"/></g></svg>VON HIER</div>',
              callback: this.routeOrigin,
            },
            {
              text: '<div style="display: flex; gap: 5px; padding: 5px;"><svg style="height:20px" viewBox="0 0 512 512"><g fill="white"><circle cx="256" cy="256" r="200" /></g><g fill="#CC1414"><path class="st0" d="M256,49C141.7,49,49,141.7,49,256s92.7,207,207,207s207-92.7,207-207S370.3,49,256,49z M262.6,361.1h-63.9V151.6h61.2c43.2,0,63,16.2,63,51.6c0,33.3-21,43.2-34.8,48.3v0.6c16.2,3.6,39.6,15,39.6,50.1C327.7,340.4,299.8,361.1,262.6,361.1z"/><path class="st0" d="M285.7,208.1c0-17.7-12.6-28.2-30.9-28.2h-18.9v59.4h19.8C274.6,239.3,285.7,225.2,285.7,208.1z"/><path class="st0" d="M256,267.5h-20.1v64.2h21.3c20.7,0,32.1-12.6,32.1-32.1C289.3,281.3,279.7,267.5,256,267.5z"/></g></svg>HIERHER</div>',
              callback: this.routeDestination,
            },
          ]}
        >
          <LayersControl position="topright">
            <LayersControl.Overlay checked name="Haltestellen">
              <LayerGroup>
                {this.props.stations &&
                  this.state.zoom > 12 &&
                  !this.props.location.pathname.includes("departureDetail") &&
                  !(this.props.trip && this.props.trip.partialTrips)
                  ? this.props.stations.map((station, index) => {
                    return (
                      // eslint-disable-next-line eqeqeq
                      station &&
                        station.externalID !== "" &&
                        station.externalID != 0 ? (
                        <div key={index}>
                          <StationMarker
                            station={station}
                            setOrigin={() => {
                              this.setOrigin(station);
                            }}
                            setDestination={() => {
                              this.setDestination(station);
                            }}
                          />
                          {station.elevators.length > 0 &&
                            this.state.zoom > 16 ? (
                            <div>
                              {station.elevators.map((elevator, index_) => {
                                return (
                                  <ElevatorMarker
                                    elevator={elevator}
                                    station={station}
                                    key={index_}
                                    setOrigin={this.setOrigin}
                                    setDestination={this.setDestination}
                                  />
                                );
                              })}
                              {station.escalators.map((escalator, index_) => {
                                return (
                                  <EscalatorMarker
                                    escalator={escalator}
                                    station={station}
                                    key={index_}
                                    setOrigin={this.setOrigin}
                                    setDestination={this.setDestination}
                                  />
                                );
                              })}
                            </div>
                          ) : null}
                        </div>
                      ) : null
                    );
                  })
                  : null}
              </LayerGroup>
            </LayersControl.Overlay>
            <LayersControl.Overlay name="Aufzüge">
              <LayerGroup>
                {elevators.map((elevator, index) => {
                  return (
                    // eslint-disable-next-line eqeqeq
                    elevator ? (
                      <ElevatorMarker
                        elevator={elevator}
                        station={elevator.station}
                        key={index}
                      />
                    ) : null
                  );
                })}
              </LayerGroup>
            </LayersControl.Overlay>
            <LayersControl.Overlay name="Fahrtreppen">
              <LayerGroup>
                {escalators.map((escalator, index) => {
                  return (
                    // eslint-disable-next-line eqeqeq
                    escalator ? (
                      <EscalatorMarker
                        escalator={escalator}
                        station={escalator.station}
                        key={index}
                      />
                    ) : null
                  );
                })}
              </LayerGroup>
            </LayersControl.Overlay>
            )
            {this.props.locations ? (
              <div>
                {this.props.locations.map((location, index) => {
                  if (location.id === 3) {
                    return (
                      <LayersControl.Overlay
                        checked
                        name={location.name}
                        key={index}
                      >
                        <LayerGroup>
                          {location.locations
                            ? location.locations.map((loc, index) => {
                              return loc && this.state.zoom > 13 ? (
                                <LocationMarker
                                  setOrigin={this.setOrigin}
                                  setDestination={this.setDestination}
                                  loc={loc}
                                  locationIcon={
                                    location.id === 1
                                      ? loc.spot
                                        ? metropolRadRuhr
                                        : metropolRadRuhrBike
                                      : location.id === 3
                                        ? kundencenter
                                        : location.id === 18
                                          ? parkAndRide
                                          : location.id === 20
                                            ? stadtmobil
                                            : location.id === 23
                                              ? bikeAndRide
                                              : null
                                  }
                                  key={index}
                                />
                              ) : null;
                            })
                            : null}
                        </LayerGroup>
                      </LayersControl.Overlay>
                    );
                  } else {
                    return null;
                  }
                })}
                {this.props.locations.map((location, index) => {
                  if (location.id !== 3) {
                    return (
                      <LayersControl.Overlay
                        checked
                        name={location.name}
                        key={index}
                      >
                        <LayerGroup>
                          {location.locations &&
                            location.locations.map((loc, index) => {
                              return loc && this.state.zoom > 13 ? (
                                <LocationMarker
                                  setOrigin={this.setOrigin}
                                  setDestination={this.setDestination}
                                  loc={loc}
                                  locationIcon={
                                    location.id === 1
                                      ? loc.spot
                                        ? metropolRadRuhr
                                        : metropolRadRuhrBike
                                      : location.id === 3
                                        ? kundencenter
                                        : location.id === 18
                                          ? parkAndRide
                                          : location.id === 20
                                            ? stadtmobil
                                            : location.id === 23
                                              ? bikeAndRide
                                              : null
                                  }
                                  key={index}
                                />
                              ) : null;
                            })}
                        </LayerGroup>
                      </LayersControl.Overlay>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            ) : null}
            <LayersControl.BaseLayer checked name="Standard">
              <TileLayer url="https://tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=66635498e5084f2f93a01fed90bd7404" />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Alternative">
              <TileLayer url="https://tile.thunderforest.com/neighbourhood/{z}/{x}/{y}.png?apikey=66635498e5084f2f93a01fed90bd7404" />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Transport">
              <TileLayer url="https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=66635498e5084f2f93a01fed90bd7404" />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Transport Dunkel">
              <TileLayer url="https://tile.thunderforest.com/transport-dark/{z}/{x}/{y}.png?apikey=66635498e5084f2f93a01fed90bd7404" />
            </LayersControl.BaseLayer>
          </LayersControl>
          {this.props.userPosition.length > 0 ? (
            <Marker
              position={[
                this.props.userPosition[0] / 1000000,
                this.props.userPosition[1] / 1000000,
              ]}
              icon={PositionBullsEyeIcon}
            >
              <Popup>Sie sind hier</Popup>
            </Marker>
          ) : null}
          {this.props.trip && this.props.trip.partialTrips ? (
            <div>
              {this.props.trip.partialTrips.map((partialTrip, index) => {
                if (partialTrip.color == "#EEEE18") {
                  partialTrip.path.pop();
                }
                return (
                  <Polyline
                    key={index}
                    weight="7"
                    pathOptions={{ color: partialTrip.color }}
                    positions={partialTrip.path}
                  />
                );
              })}
              {this.props.trip.partialTrips.map((partialTrip, index) => {
                if (partialTrip.color == "#EEEE18") {
                  partialTrip.footpath.pop();
                }
                return (
                  <Polyline
                    key={index}
                    weight="7"
                    dashArray="20,20"
                    pathOptions={{ color: "#69AA18" }}
                    positions={partialTrip.footpath}
                  />
                );
              })}
              {this.props.trip.partialTrips.map((partialTrip, index) => {
                return (
                  <div key={index}>
                    {partialTrip.color !== "#69AA18"
                      ? partialTrip.stations.map((station, index) => {
                        // eslint-disable-next-line eqeqeq
                        if (
                          this.props.selectedStation &&
                          this.props.selectedStation == station.id
                        ) {
                          return (
                            <Marker
                              position={station.coords}
                              icon={
                                partialTrip.id === "1"
                                  ? LargeUBahnCircleIcon
                                  : partialTrip.id === "S-Bahn"
                                    ? LargeSBahnCircleIcon
                                    : partialTrip.id === "Niederflurbus" ||
                                      partialTrip.id === "8" ||
                                      partialTrip.id === "3"
                                      ? LargeBusCircleIcon
                                      : partialTrip.id === "Straßenbahn"
                                        ? LargeTramCircleIcon
                                        : partialTrip.id === "Regionalzug"
                                          ? LargeRECircleIcon
                                          : LargeBusCircleIcon
                              }
                              key={index}
                            />
                          );
                        } else {
                          return (
                            <Marker
                              position={station.coords}
                              icon={
                                partialTrip.id === "U-Bahn"
                                  ? UBahnCircleIcon
                                  : partialTrip.id === "S-Bahn"
                                    ? SBahnCircleIcon
                                    : partialTrip.id === "Niederflurbus" ||
                                      partialTrip.id === "8" ||
                                      partialTrip.id === "3"
                                      ? BusCircleIcon
                                      : partialTrip.id === "Straßenbahn"
                                        ? TramCircleIcon
                                        : partialTrip.id === "Regionalzug"
                                          ? RECircleIcon
                                          : BusCircleIcon
                              }
                              key={index}
                            >
                              <Popup>{station.name}</Popup>
                            </Marker>
                          );
                        }
                      })
                      : null}
                  </div>
                );
              })}
            </div>
          ) : this.props.stopFinderResponse &&
            this.props.stopFinderResponse.data ? (
            this.props.stopFinderResponse.data.map((station, index) => {
              return (
                // eslint-disable-next-line eqeqeq
                station &&
                  station.externalID !== "" &&
                  station.externalID != 0 &&
                  station.coords &&
                  station.type === "stop" &&
                  index < 20 ? (
                  <StationMarker
                    station={station}
                    setOrigin={() => {
                      this.setOrigin(station);
                    }}
                    setDestination={() => {
                      this.setOrigin(station);
                    }}
                    key={index}
                  />
                ) : null
              );
            })
          ) : this.props.departureStation.station &&
            this.props.location.pathname.includes("departureDetail") ? (
            <StationMarker
              station={this.props.departureStation.station}
              setOrigin={() => {
                this.setOrigin(this.props.departureStation.station);
              }}
              setDestination={() => {
                this.setOrigin(this.props.departureStation.station);
              }}
            />
          ) : null}
          {this.props.origin && this.props.origin.coords ? (
            <Marker
              position={[
                this.props.origin.coords.lat,
                this.props.origin.coords.long,
              ]}
              icon={LocationAMapIcon}
            >
              <Popup>Start Position</Popup>
            </Marker>
          ) : null}
          {this.props.destination && this.props.destination.coords ? (
            <Marker
              position={[
                this.props.destination.coords.lat,
                this.props.destination.coords.long,
              ]}
              icon={LocationBMapIcon}
            >
              <Popup>Ziel Position</Popup>
            </Marker>
          ) : null}
        </MapContainer>
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    trip: state.selectedTrip,
    origin: state.originTrip,
    destination: state.destinationTrip,
    stations: state.stations,
    locations: state.locations,
    userPosition: state.userPosition,
    stopFinderResponse: state.stopFinder,
    selectedStation: state.selectedStation,
    departureStation: state.departure,
    city: state.city,
  };
};

let mapDispatchToProps = {
  setStations: setStations,
  setLocations: setLocations,
  getRoutes: getRoutes,
  setOrigin: setOrigin,
  setDestination: setDestination,
  requestTrip: requestTrip,
  setUserPosition: setUserPosition,
  setCity: setCity,
};

let MapViewPage = connect(mapStateToProps, mapDispatchToProps)(MapView);
export default withRouter(MapViewPage);
